import { render, staticRenderFns } from "./TraxTrainingCourseEditMap.vue?vue&type=template&id=edf95418&scoped=true"
import script from "./TraxTrainingCourseEditMap.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCourseEditMap.vue?vue&type=script&lang=js"
import style0 from "./TraxTrainingCourseEditMap.vue?vue&type=style&index=0&id=edf95418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf95418",
  null
  
)

export default component.exports